import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSword: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconSword"><Path d="M8 11.1087L13.9783 3.5H20.5V10.0217L12.8913 16" stroke="currentColor"/><Path d="M6 9.5L4 12L6 15L2.5 18.5L5.5 21.5L9 18L12 20L14.5 18L6 9.5Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconSword;
